import { gql } from '@apollo/client';

export const quotePriceBreakdown = gql`
  fragment QuotePriceBreakdown on QuotePriceBreakdown {
    excludingVatPrices {
      formattedToCurrency {
        commissionPrice
        priceExclCommission
        priceInclCommission
        priceInclCommissionAndServiceFee
        priceInclCommissionAndServiceFeeAndProtection
        protectionPrice
        serviceFeePrice
      }
      inPennies {
        commissionPrice
        priceExclCommission
        priceInclCommission
        priceInclCommissionAndServiceFee
        priceInclCommissionAndServiceFeeAndProtection
        protectionPrice
        serviceFeePrice
      }
    }
    includingVatPrices {
      formattedToCurrency {
        commissionPrice
        priceExclCommission
        priceInclCommission
        priceInclCommissionAndServiceFee
        priceInclCommissionAndServiceFeeAndProtection
        protectionPrice
        serviceFeePrice
      }
      inPennies {
        commissionPrice
        priceExclCommission
        priceInclCommission
        priceInclCommissionAndServiceFee
        priceInclCommissionAndServiceFeeAndProtection
        protectionPrice
        serviceFeePrice
      }
    }
  }
`;

export const priceBreakdown = gql`
  fragment PriceBreakdown on PriceBreakdown {
    excludingVatPrices {
      formattedToCurrency {
        commissionPrice
        priceExclCommission
        priceInclCommission
        priceInclCommissionAndServiceFee
        serviceFeePrice
      }
      inPennies {
        commissionPrice
        priceExclCommission
        priceInclCommission
        priceInclCommissionAndServiceFee
        serviceFeePrice
      }
    }
    includingVatPrices {
      formattedToCurrency {
        commissionPrice
        priceExclCommission
        priceInclCommission
        priceInclCommissionAndServiceFee
        serviceFeePrice
      }
      inPennies {
        commissionPrice
        priceExclCommission
        priceInclCommission
        priceInclCommissionAndServiceFee
        serviceFeePrice
      }
    }
  }
`;
